exports.citiesGeo = {
    "Austin": { "lat": 30.2672, "lng": -97.7431 },
    "Laredo": { "lat": 27.5036, "lng": -99.5075 },
    "Philadelphia": { "lat": 39.9526, "lng": -75.1652 },
    "San Jose": { "lat": 37.3382, "lng": -121.8863 },
    "Orlando": { "lat": 28.5383, "lng": -81.3792 },
    "Tampa": { "lat": 27.9506, "lng": -82.4572 },
    "San Antonio": { "lat": 29.4241, "lng": -98.4936 },
    "Chicago": { "lat": 41.8781, "lng": -87.6298 },
    "Stockton": { "lat": 37.9577, "lng": -121.2908 },
    "Seattle": { "lat": 47.6062, "lng": -122.3321 },
    "Columbus": { "lat": 39.9612, "lng": -82.9988 },
    "Buffalo": { "lat": 42.8864, "lng": -78.8784 },
    "Denver": { "lat": 39.7392, "lng": -104.9903 },
    "Oklahoma City": { "lat": 35.4676, "lng": -97.5164 },
    "Oakland": { "lat": 37.8049, "lng": -122.2711 },
    "Riverside": { "lat": 33.9806, "lng": -117.3755 },
    "Kansas City": { "lat": 39.0997, "lng": -94.5786 },
    "Baltimore": { "lat": 39.2904, "lng": -76.6122 },
    "Nashville": { "lat": 36.1627, "lng": -86.7816 },
    "Honolulu": { "lat": 21.3069, "lng": -157.8583 },
    "Memphis": { "lat": 35.1495, "lng": -90.0490 },
    "St. Paul": { "lat": 44.9537, "lng": -93.0900 },
    "Boston": { "lat": 42.3601, "lng": -71.0589 },
    "Wichita": { "lat": 37.6872, "lng": -97.3301 },
    "El Paso": { "lat": 31.7619, "lng": -106.4850 },
    "Plano": { "lat": 33.0198, "lng": -96.6989 },
    "Atlanta": { "lat": 33.7490, "lng": -84.3880 },
    "Jersey City": { "lat": 40.7178, "lng": -74.0431 },
    "St. Petersburg": { "lat": 27.7676, "lng": -82.6403 },
    "Detroit": { "lat": 42.3314, "lng": -83.0458 },
    "Cincinnati": { "lat": 39.1031, "lng": -84.5120 },
    "New York": { "lat": 40.7128, "lng": -74.0060 },
    "San Diego": { "lat": 32.7157, "lng": -117.1611 },
    "Tucson": { "lat": 32.2226, "lng": -110.9747 },
    "Chattanooga": { "lat": 35.0456, "lng": -85.3097 },
    "Colorado Springs": { "lat": 38.8339, "lng": -104.8214 },
    "Chula Vista": { "lat": 32.6401, "lng": -117.0842 },
    "Newark": { "lat": 40.7357, "lng": -74.1724 },
    "Jacksonville": { "lat": 30.3322, "lng": -81.6557 },
    "Aurora": { "lat": 39.7294, "lng": -104.8319 },
    "Fort Wayne": { "lat": 41.0793, "lng": -85.1394 },
    "Gilbert": { "lat": 33.3528, "lng": -111.7890 },
    "Santa Ana": { "lat": 33.7455, "lng": -117.8677 },
    "Hialeah": { "lat": 25.8576, "lng": -80.2785 },
    "Miami": { "lat": 25.7617, "lng": -80.1918 },
    "Madison": { "lat": 43.0731, "lng": -89.4012 },
    "Fort Worth": { "lat": 32.7555, "lng": -97.3308 },
    "Bakersfield": { "lat": 35.3733, "lng": -119.0187 },
    "Minneapolis": { "lat": 44.9778, "lng": -93.2650 },
    "Garland": { "lat": 32.9126, "lng": -96.6389 },
    "Arlington": { "lat": 32.7357, "lng": -97.1081 },
    "Phoenix": { "lat": 33.4484, "lng": -112.0740 },
    "Greensboro": { "lat": 36.0726, "lng": -79.7910 },
    "Indianapolis": { "lat": 39.7684, "lng": -86.1581 },
    "Glendale": { "lat": 33.5387, "lng": -112.1854 },
    "Tulsa": { "lat": 36.1539, "lng": -95.9928 },
    "Cleveland": { "lat": 41.4993, "lng": -81.6944 },
    "Lincoln": { "lat": 40.8136, "lng": -96.7026 },
    "Anaheim": { "lat": 33.8366, "lng": -117.9143 },
    "Charlotte": { "lat": 35.2271, "lng": -80.8431 },
    "Portland": { "lat": 45.5152, "lng": -122.6784 },
    "Las Vegas": { "lat": 36.1699, "lng": -115.1398 },
    "Raleigh": { "lat": 35.7796, "lng": -78.6382 },
    "St. Louis": { "lat": 38.6270, "lng": -90.1994 },
    "Los Angeles": { "lat": 34.0522, "lng": -118.2437 },
    "Lexington": { "lat": 38.0406, "lng": -84.5037 },
    "Corpus Christi": { "lat": 27.8006, "lng": -97.3964 },
    "Toledo": { "lat": 41.6540, "lng": -83.5379 },
    "Henderson": { "lat": 36.0395, "lng": -114.9817 },
    "San Francisco": { "lat": 37.7749, "lng": -122.4194 },
    "Washington": { "lat": 38.9072, "lng": -77.0369 },
    "Dallas": { "lat": 32.7767, "lng": -96.7970 },
    "Houston": { "lat": 29.7604, "lng": -95.3698 }

}

exports.defaultLocation = { lat: 37.7749, lng: -122.4194 };
